export default __webpack_public_path__ + "static/media/euro-bills.84dbe059.svg";